module.exports = __webpack_public_path__ + "img/btn-close.fbf2cf2b.svg";